import { render, staticRenderFns } from "./ControlHeader.vue?vue&type=template&id=0c5b9fb4&scoped=true"
import script from "./ControlHeader.vue?vue&type=script&lang=js"
export * from "./ControlHeader.vue?vue&type=script&lang=js"
import style0 from "./ControlHeader.vue?vue&type=style&index=0&id=0c5b9fb4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5b9fb4",
  null
  
)

export default component.exports